export default __webpack_public_path__ + "3fb690e8c06497f5476c41e8acab4fc8.svg";